import { useScrollToTop } from '../../hooks/useScrollToTop';

const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

export default ScrollToTop;